import styled from 'styled-components';

export const Container = styled.div`
  padding: 72px;
  overflow: scroll;

  background: #f1f4f5;
`;

export const Header = styled.div`
  margin-bottom: 45px;
`;

export const Description = styled.div`
  margin-bottom: 72px;
`;

export const ActionButtons = styled.div`
  gap: 24px;

  display: flex;
  flex-direction: row;
`;
